<app-header-content-help-text [Heading]="'Data Processing'" [helpText]="'Manual Upload for key Data points'"></app-header-content-help-text>
<app-upload-files-molecules></app-upload-files-molecules>
